module.exports = __webpack_public_path__ + "assets/fonts/ProximaNova-Light.3519871a.ttf";